import styled from 'styled-components';
import { black, deepSeaBlue } from '../../global-styles';

const Body = styled.h6`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  font-weight: ${props => (props.bold ? 600 : 400)};
  color: ${props => (props.color ? props.color : black)};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: ${props => (props.bold ? '.2px' : 'normal')};
  > span {
    font-weight: 600;
    color: ${deepSeaBlue};
  }
`;

export default Body;
